import { createFileRoute } from "@tanstack/react-router";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtMoney, fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export const Route = createFileRoute("/_authenticated/admin/withdrawals")({ component: AdminWd });

function AdminWd() {
  const qc = useQueryClient();
  const { data: rows = [] } = useQuery({
    queryKey: ["admin-wd"],
    queryFn: async () => (await supabase.from("withdrawals").select("*").order("created_at", { ascending: false })).data ?? [],
  });

  const decide = useMutation({
    mutationFn: async ({ id, approve }: { id: string; approve: boolean }) => {
      const { error } = await supabase.rpc("admin_decide_withdrawal", { _withdrawal_id: id, _approve: approve });
      if (error) throw error;
    },
    onSuccess: () => { toast.success("Updated"); qc.invalidateQueries(); },
    onError: (e: Error) => toast.error(e.message),
  });

  return (
    <div className="glass rounded-2xl overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>User</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Address</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((d) => (
            <TableRow key={d.id}>
              <TableCell className="text-xs text-muted-foreground">{fmtDate(d.created_at)}</TableCell>
              <TableCell className="font-mono text-xs">{d.user_id.slice(0, 8)}…</TableCell>
              <TableCell className="font-mono">{fmtMoney(d.amount)}</TableCell>
              <TableCell className="font-mono text-xs">{d.btc_address.slice(0, 14)}…</TableCell>
              <TableCell><Badge variant="outline" className="capitalize">{d.status}</Badge></TableCell>
              <TableCell className="text-right space-x-2">
                {d.status === "pending" && (
                  <>
                    <Button size="sm" onClick={() => decide.mutate({ id: d.id, approve: true })}>Approve</Button>
                    <Button size="sm" variant="outline" onClick={() => decide.mutate({ id: d.id, approve: false })}>Reject</Button>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}